import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';


export interface StoreMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface StoreMst {
    id?: any;
    tenantId: any;
    branchId: any;  
    name:string;
    isActive:string;
    
    parameters?: StoreMstParameter[];
    links?: any;
}
export abstract class StoreMstData {    
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<StoreMst[]>;
    abstract create(url: string, data: StoreMst): Observable<StoreMst[]>;
    abstract update(url: string, data: StoreMst): Observable<StoreMst>;
    abstract delete(url: string): Observable<any>;
}